// components/ErrorFallback.js
import React from 'react';

const ErrorFallback = ({title, image }) => {
  return (
    <div role="alert" className={title === 'Performance'?'': 'border rounded-0 px-3 py-4'}>

      {title !=='Performance' && (
        <h4 className='info-header-title'>{title}</h4>
      )}
    <div  className='d-flex flex-column align-items-center justify-content-center'>
      <img src={image} alt="Error Visual" className='error-img'/>
      <small>No data available.</small>
    </div>
    </div>
  );
};

export default ErrorFallback;
